import EventProgressItem from "./Entities/EventProgressData";

export {EventProgress as default};

/**
* Event Progress
*
* @author      rsimoes <ruben-r-simoes@telecom.pt>
* @copyright   Copyright (C) Sapo. All rights reserved.
* @license     Private
* @since       7.0.0
*/
class EventProgress {
  /**
   * Stores all events
   *
   * @public
   *
   * @since 7.0.0
   *
   * @type {Object}
   */
  events = {};

  /**
   * Adds an new progress event to the list
   *
   * If the event already exits adds the items to the
   * event instead of creating a new event
   *
   * @public
   *
   * @since 7.0.0
   *
   * @param {String} id    event id
   * @param {Array}  items event items
   *
   * @return {void}
   */
  addEvent(id, items) {
    if (this.events[id]) {
      this.events[id].queue.addItemsAsKeys(items);
      return;
    }

    this.events[id]       = new EventProgressItem();
    this.events[id].id    = id;
    this.events[id].queue.addItemsAsKeys(items);
    this.events[id].updateProgress();
  }

  /**
   * Adds Items Progress to an event
   *
   * All add items will increade the event progress
   *
   * @public
   *
   * @since 7.0.0
   *
   * @param {String} id    event id
   * @param {Array}  items event items
   *
   * @return {void}
   */
  addEventItemsProgress(id, items) {
    if (!this.events[id]) {
      return;
    }

    this.events[id].finished.addItemsAsKeys(items);
    this.events[id].updateProgress();
  }

  /**
   * Deletes an event from the list
   *
   * @public
   *
   * @param {String} id event id
   *
   * @since 7.0.0
   *
   * @return {void}
   */
  deleteEvent(id) {
    delete this.events[id];
  }
}